export default {
    // 模块名称
    carPatrolBlack: {
        // 按钮类
        button: {
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            view: 'View',
            cancel:'Cancel',
            confirm:'Confirm',
            save:'Save',
            close:'Close',
            create:'Create',
            search:'Query',
            reset:'Reset',
            checkAll:'checkAll',
        },
        // 文字标签类
        label: {
            blackName:'BlacklistName',
            describe:'Describe',
            number:'Number',
            owner:'Owner',
            createDate:'CreateTime',
            remark:'Remark',
            picture:'Picture',
            blackList:'BlackList',
            type:'Type',
            color:'Color',
            unlimit: 'Unlimited'
        },
        // 提示类
        placeholder: {
            nameFilter:'Please enter a name to filter',
            blackName:'Please enter the name of the blacklist group',
            describe:'Please enter description',
            blackList:'Please enter a list of blacklist groups',
            number:'Please enter license plate',
            owner:'Please enter the owner name',
            color:'Please select the body color',
            type:'Please select vehicle type',
            startTime: 'Start Time',
            endTime: 'End Time'
        },
        // 消息类
        message: {
            deleteNameList: 'Select the list to delete',
            choseNameList: 'Delete the selected list. Do you want to continue?',
            choseGroup: 'Select list group',
            deleteList: 'Delete list group, do you want to continue?',
            deleteOk: 'Delete the success',
            deleteNo: 'Delete failed',
            noChoseList: 'Unselected list group',
            searchWarn:'Vehicle blacklist query time span not more than 30 days!',
            upWarn:'Maximum upload 1 image',
            formatWarn:'The picture format is not correct, please choose again',
            sizeWarn:'The size of the picture should not exceed 4M',
            failUp:'Picture upload failed',
            selectlist: 'Please select a blacklist group list',
            inputno: 'Enter plate number',
            carformat: 'Plate number format error',
            ownerformat: 'Owner format error'
        },
        // 标题类
        title: {
            addOk: 'New success',
            editOk: 'Modify the success',
            remind: 'prompt',
            nameList:'List group details',
            addBlack:'Add blacklist group',
            editBlack: 'Modify blacklist group',
            blackList: 'blacklist',
            whiteBlack: 'whitelist',
            addCars: 'New blacklist for vehicles',
            editCars: 'Vehicle blacklist modification'
        }
    }
}